/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Teal_Bronze_Frog_SwimInputs */

const en_teal_bronze_frog_swim = /** @type {(inputs: Teal_Bronze_Frog_SwimInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete old users after import`)
};

const de_teal_bronze_frog_swim = /** @type {(inputs: Teal_Bronze_Frog_SwimInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alte Benutzer nach Import löschen`)
};

/**
* | output |
* | --- |
* | "Delete old users after import" |
*
* @param {Teal_Bronze_Frog_SwimInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const teal_bronze_frog_swim = /** @type {((inputs?: Teal_Bronze_Frog_SwimInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Teal_Bronze_Frog_SwimInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_teal_bronze_frog_swim(inputs)
	return de_teal_bronze_frog_swim(inputs)
});